import { render, staticRenderFns } from "./IncidentView.vue?vue&type=template&id=e493858c&scoped=true"
import script from "./IncidentView.vue?vue&type=script&lang=js"
export * from "./IncidentView.vue?vue&type=script&lang=js"
import style0 from "./IncidentView.vue?vue&type=style&index=0&id=e493858c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e493858c",
  null
  
)

export default component.exports